// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3dOhI","row":"ProcedureTreatmentSummary_row__30vOG"};